import { tryParseInteger } from "@arktype/util";
export const parseDivisor = (s) => {
    const divisorToken = s.scanner.shiftUntilNextTerminator();
    const divisor = tryParseInteger(divisorToken, {
        errorOnFail: writeInvalidDivisorMessage(divisorToken)
    });
    if (divisor === 0)
        s.error(writeInvalidDivisorMessage(0));
    s.root = s.root.constrain("divisor", divisor);
};
export const writeInvalidDivisorMessage = (divisor) => `% operator must be followed by a non-zero integer literal (was ${divisor})`;
